import React, { Component } from "react";
import PropTypes from "prop-types";

import placeholder_profile from "images/core/placeholders/default_avatar.png";
import placeholder_team from "images/core/placeholders/placeholder_team.jpg";
import "./LeaderboardPlayer.css";
import {
  PROJECT_USER,
  USER,
  PROJECT_PROFILE,
  PROFILE,
  PROJECT_TEAM,
  TEAM
} from "App/Routes";
import Link from "components/shared/Link/Link";

import localize from "lang/localize";

const propTypes = {
  id: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  userId: PropTypes.number,
  rank: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  points: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  self: PropTypes.bool.isRequired,
  isTeam: PropTypes.bool.isRequired,
  language: PropTypes.string
};

class LeaderboardPlayer extends Component {
  getLink() {
    if (this.props.isTeam && this.props.projectId) {
      return PROJECT_TEAM.format(this.props.projectId, this.props.id);
    } else if (this.props.isTeam) {
      return TEAM.format(this.props.id);
    } else if (this.props.userId === this.props.id && this.props.projectId) {
      return PROJECT_PROFILE.format(this.props.projectId);
    } else if (this.props.userId === this.props.id) {
      return PROFILE;
    } else if (this.props.projectId) {
      return PROJECT_USER.format(this.props.projectId, this.props.id);
    } else {
      return USER.format(this.props.id);
    }
  }

  renderImage() {
    /* An empty image will be returned as 'undefined', ie. not a string */
    if (typeof this.props.image !== "string") {
      if (this.props.isTeam) {
        return placeholder_team;
      } else {
        return placeholder_profile;
      }
    } else {
      return this.props.image;
    }
  }

  render() {
    let image = this.renderImage();
    let name = this.props.name;
    let link = this.getLink();

    return (
      <Link to={link}>
        <div className="leaderboard-player">
          <div
            className={
              "pure-g bottommargin" +
              (this.props.self ? " self highlightborder" : "")
            }
          >
            <div className="pure-u-3-24 relative">
              <h4 className="leaderboard-rank">{this.props.rank}</h4>
            </div>
            <div className="pure-u-3-24">
              {this.props.rank === 1 && (
                <div id="crown" className="photo-icon-wrap">
                  <span className="leaderboard-champion" />
                </div>
              )}
              <span className="square-image-wrapper">
                <span className="square-image circle">
                  <img src={image} alt={name} />
                </span>
              </span>
            </div>
            <div className="pure-u-1-24" />
            <div className="pure-u-10-24 relative">{name}</div>
            <div className="pure-u-6-24 relative">
              <div className="textright">
                <strong>{this.props.points.abbreviateNumber()}</strong>
                <br />
                <span className="smalltext">
                  {localize("points_just_text", this.props.language)}
                </span>
              </div>
            </div>
            <div className="pure-u-1-24" />
          </div>
        </div>
      </Link>
    );
  }
}

LeaderboardPlayer.propTypes = propTypes;

export default LeaderboardPlayer;
